import { isWidthResize, debounce } from "../common/utils";
import { Resolutions } from '../common/const';

export const initProdDetailFooter = () => {
    const header = document.querySelector(`.header`);
    let height = header.offsetHeight;

    let scrollPos = 0;
    const productFooter = document.querySelector(`[data-product-footer]`);
    const footer = document.querySelector(`.footer`);

    // Change fixed class depending on document scrollTop
    function onWindowScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // появление футера в карточке товара
        if (productFooter) {
            if (Resolutions.IS_DP()) {
                if (
                    document.querySelector(`.prod-detail__info`).getBoundingClientRect().top - height <= 0 &&
                    footer.getBoundingClientRect().top - screen.height > 0
                ) {
                    productFooter.classList.add(`fixed`);
                } else {
                    productFooter.classList.remove(`fixed`);
                }
            } else {
                console.log('mobile')
                if (footer.getBoundingClientRect().top - screen.height > 0) {
                    productFooter.classList.remove(`hidden`);
                } else {
                    productFooter.classList.add(`hidden`);
                }
            }
        }

        scrollPos = scrollTop;
    }

    function setWindowScroll() {
        const debouncedScroll = debounce(onWindowScroll, 100);
        window.removeEventListener(`scroll`, debouncedScroll);
        window.addEventListener(`scroll`, debouncedScroll);
    }

    setWindowScroll();
    isWidthResize(setWindowScroll);
};
